// 스테이션(독) 저장 용량: 총 용량 (단위: KB), 사용 중 (단위: KB)
export interface AirportStorage {
  total: number, // 단위: KB
  used: number
}

// 커버 상태
export enum CoverStateEnum {
  Close = 0, // 닫힘
  Open = 1, // 열림
  HalfOpen = 2, // 절반 열림
  Failed = 3 // 실패
}

// 푸시로드 상태
export enum PutterStateEnum {
  Close = 0, // 닫힘
  Open = 1, // 열림
  HalfOpen = 2, // 절반 열림
  Failed = 3 // 실패
}

// 충전 상태
export enum ChargeStateEnum {
  NotCharge = 0, // 대기
  Charge = 1, // 충전 중
}

export interface DroneChargeState {
  state: ChargeStateEnum,
  capacity_percent: string,
}

// 보조등 상태
export enum SupplementLightStateEnum {
  Close = 0, // 꺼짐
  Open = 1, // 켜짐
}

// 스테이션(독) 시청각 알람 상태
export enum AlarmModeEnum {
  CLOSE = 0, // 꺼짐
  OPEN = 1, // 켜짐
}

// 배터리 관리
export enum BatteryStoreModeEnum {
  BATTERY_PLAN_STORE = 1, // 배터리 예약 보관 모드
  BATTERY_EMERGENCY_STORE = 2, // 배터리 비상 보관 모드
}

// 드론 배터리 관리
export enum DroneBatteryStateEnum {
  NoMaintenanceRequired = 0, // 0-관리 필요 없음
  MaintenanceRequired = 1, // 1-관리 대기 중
  MaintenanceInProgress = 2, // 2-관리 중
}

export enum DroneBatteryModeEnum {
  CLOSE = 0, // 꺼짐
  OPEN = 1, // 켜짐
}

// 4G 링크 연결 상태
export enum FourGLinkStateEnum {
  CLOSE = 0, // 끊김
  OPEN = 1, // 연결됨
}

// SDR 링크 연결 상태
export enum SdrLinkStateEnum {
  CLOSE = 0, // 끊김
  OPEN = 1, // 연결됨
}

// 스테이션(독) 영상 전송 링크 모드
export enum LinkWorkModeEnum {
  SDR = 0, // SDR 모드
  FourG_FUSION_MODE = 1, // 4G 융합 모드
}
